exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* 弹窗宽度 */\n.lite_popup_box {\n  width: 11.111111rem;\n}", "", {"version":3,"sources":["C:/Users/Nokia/Documents/code/MC/mcFrontend/src/components/workspace/lite_confirm.vue"],"names":[],"mappings":"AAAA,UAAU;AAEV;EACE,oBAAoB;CACrB","file":"lite_confirm.vue","sourcesContent":["/* 弹窗宽度 */\n\n.lite_popup_box {\n  width: 11.111111rem;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-957c660e","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/workspace/lite_confirm.vue
// module id = ghn9
// module chunks = 1